import { useMemo } from "react";
import { BurnQualityCountAggregateByTime } from "../BurnQualityCountAggregateByTime";
import { BurnQualityCountDataPoints } from "../BurnQualityCountDataPoints";
import { DateTimeUnit, Interval } from "luxon";
import { notUndef } from "shared-ts-utils-core";

export const useDataSet = (
  aggregates: Array<BurnQualityCountAggregateByTime> | undefined,
  interval: Interval<true>,
  timeUnit: DateTimeUnit
): BurnQualityCountDataPoints => {
  const dataPoints = useMemo(() => {
    return (
      notUndef(aggregates, (aggregates) =>
        BurnQualityCountDataPoints.fromAggregates(aggregates)
      ) ?? BurnQualityCountDataPoints.empty()
    );
  }, [aggregates]);

  return useMemo(() => {
    return dataPoints.between(interval, timeUnit);
  }, [dataPoints, interval, timeUnit]);
};
